module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-agility-582.b2d34862e3b9a039.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-agility-582.b2d34862e3b9a039.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-agility-582.b2d34862e3b9a039.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-agility-582.b2d34862e3b9a039.png"},
        
        width: 582,
        height: 400
      }